import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  ContentSection,
  ContentSectionHeading,
  ContentSectionWrapper,
  Image,
} from 'shared/SectionControl/NewSectionModal/components/ModalContent/pages/style'

import PricingSectionImage from '../../assets/PricingSection/pricing-section.png'

export const PricingPage = () => {
  const { t } = useTranslation()

  return (
    <ContentSectionWrapper>
      <ContentSectionHeading>{t('Pricing section')}</ContentSectionHeading>
      <ContentSection>
        <Image alt="" src={PricingSectionImage} />
      </ContentSection>
    </ContentSectionWrapper>
  )
}
